module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "part",
    attrs: {
      "epub:type": "part"
    }
  }, [_c('h2', [_c('span', {
    staticClass: "h2-inner"
  }, [_vm._v("Part One")])]), _vm._v(" "), _c('h3', [_c('span', {
    staticClass: "h3-inner"
  }, [_vm._v("Naseby Field")])]), _vm._v(" "), _c('blockquote', {
    staticClass: " bq"
  }, [_c('p', {
    staticClass: " firstInSection"
  }, [_vm._v("“I could not, riding out alone about my business, but smile out to God in praises, in assurance of victory because God would, by things that are not, bring to naught things that are.”")])]), _vm._v(" "), _c('p', {
    staticClass: "source firstInSection"
  }, [_vm._v("Cromwell before the Battle of Naseby")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbc6f20e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter4.vue
// module id = 75
// module chunks = 0